import {appFetch, AppFetchResponse} from "../utils/appFetch";
import {FilterProps} from "../components/table/tableTypes";

export const getAbandonedCheckoutsPreview = async (selectedDomain: string): Promise<AppFetchResponse> => {
    return appFetch({
        endpoint: `abandoned-checkouts-preview?domain=${selectedDomain}`,
        method: 'GET',
        headers: {
            "Content-Type": "application/json",
        },
        domain: selectedDomain,
        isEncrypted: true,
    });
}